export const SIMPLE_UPLOAD_BYTES = 4 * 1024 * 1024;   // SharePoint simple-upload cap — above this we chunk
export const MAX_UPLOAD_BYTES = 250 * 1024 * 1024;

/** Send a big file to SharePoint in ~3MB pieces via a Graph upload session. Resolves to the created file. */
export async function uploadInChunks(api, entityType, entityId, file, subfolder, onProgress) {
  const { data: session } = await api.post(`/${entityType}s/${entityId}/files/upload-session`, {
    subfolder, filename: file.name, size: file.size,
  });
  let start = 0;
  while (start < file.size) {
    const end = Math.min(start + session.chunk_size, file.size);
    const { data } = await api.put(
      `/${entityType}s/${entityId}/files/upload-session/${session.session_id}`,
      file.slice(start, end),
      { headers: { 'Content-Type': 'application/octet-stream', 'Content-Range': `bytes ${start}-${end - 1}/${file.size}` }, timeout: 180000 },
    );
    start = end;
    onProgress?.(start / file.size);
    if (data.status === 'done') return data.file;
  }
  throw new Error('Upload did not complete');
}

export const isImageName = (name = '') => /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/i.test(name);
